/* eslint-disable */
// @ts-nocheck

let REMOVE = 'remove'
let REPLACE = 'replace'
let ADD = 'add'
let MOVE = 'move'

type Operation = 'add' | 'replace' | 'remove' | 'move'

type DiffOps = Array<{
  op: Operation
  path: Array<string | number>
  value?: any
}>

export const diffApply = <T extends Record<string, any> | undefined>(
  obj: T,
  diff: DiffOps,
  pathConverter?: PathConverter
): T => {
  if (!obj || typeof obj !== 'object') {
    throw new Error('base object must be an object or an array')
  }

  if (!Array.isArray(diff)) {
    throw new TypeError('diff must be an array')
  }

  let diffLength = diff.length
  for (let i = 0; i < diffLength; i++) {
    let thisDiff = diff[i]
    var subObject = obj
    let thisOp = thisDiff.op

    let thisPath = transformPath(pathConverter, thisDiff.path)
    let thisFromPath = thisDiff.from && transformPath(pathConverter, thisDiff.from)
    var toPath, toPathCopy, lastToProp, subToObject, valueToMove

    if (thisFromPath) {
      // MOVE only, "fromPath" is effectively path and "path" is toPath
      toPath = thisPath
      thisPath = thisFromPath

      toPathCopy = [...toPath]
      lastToProp = toPathCopy.pop()
      prototypeCheck(lastToProp)
      if (lastToProp == null) {
        return false
      }

      var thisToProp
      while ((thisToProp = toPathCopy.shift()) != null) {
        prototypeCheck(thisToProp)
        if (!(thisToProp in subToObject)) {
          subToObject[thisToProp] = {}
        }
        subToObject = subToObject[thisToProp]
      }
    }

    let pathCopy = [...thisPath]
    let lastProp = pathCopy.pop()
    prototypeCheck(lastProp)
    if (lastProp == null) {
      return false
    }

    var thisProp
    while ((thisProp = pathCopy.shift()) != null) {
      prototypeCheck(thisProp)
      if (!(thisProp in subObject)) {
        subObject[thisProp] = {}
      }
      subObject = subObject[thisProp]
    }
    if (thisOp === REMOVE || thisOp === REPLACE || thisOp === MOVE) {
      let path = thisOp === MOVE ? thisDiff.from : thisDiff.path
      if (!subObject.hasOwnProperty(lastProp)) {
        throw new Error(['expected to find property', path, 'in object', obj].join(' '))
      }
    }
    if (thisOp === REMOVE || thisOp === MOVE) {
      if (thisOp === MOVE) {
        valueToMove = subObject[lastProp]
      }
      Array.isArray(subObject) ? subObject.splice(lastProp, 1) : delete subObject[lastProp]
    }
    if (thisOp === REPLACE || thisOp === ADD) {
      subObject[lastProp] = thisDiff.value
    }

    if (thisOp === MOVE) {
      subObject[lastToProp] = valueToMove
    }
  }

  // FIXME: use diffApply from the 'just-fiff' package when the issue [https://github.com/angus-c/just/issues/590] is solved
  // FIXME: I've replaced 'return subObject' with 'return obj'
  // return subObject
  return obj
}

function transformPath(pathConverter, thisPath) {
  if (pathConverter) {
    thisPath = pathConverter(thisPath)
    if (!Array.isArray(thisPath)) {
      throw new TypeError(['pathConverter must return an array, returned:', thisPath].join(' '))
    }
  } else {
    if (!Array.isArray(thisPath)) {
      throw new TypeError(
        ['diff path', thisPath, 'must be an array, consider supplying a path converter'].join(' ')
      )
    }
  }
  return thisPath
}

function jsonPatchPathConverter(stringPath) {
  return stringPath.split('/').slice(1)
}

function prototypeCheck(prop) {
  // coercion is intentional to catch prop values like `['__proto__']`
  if (prop == '__proto__' || prop == 'constructor' || prop == 'prototype') {
    throw new Error('setting of prototype values not supported')
  }
}
